import { render, staticRenderFns } from "./order-pay.vue?vue&type=template&id=79e2b1ee"
import script from "./order-pay.vue?vue&type=script&lang=ts"
export * from "./order-pay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Navbar: require('/vercel/path0/components/navbar.vue').default,CheckoutOrderItem: require('/vercel/path0/components/checkout/order-item.vue').default,CheckoutExperience: require('/vercel/path0/components/checkout/experience.vue').default,CheckoutPaymentOptions: require('/vercel/path0/components/checkout/payment-options.vue').default,UiContactCard: require('/vercel/path0/components/ui/contact-card.vue').default,CheckoutFaq: require('/vercel/path0/components/checkout/faq.vue').default,UiContainer: require('/vercel/path0/components/ui/container.vue').default})
